import React from 'react';

interface IDrawerFormsContext {
  onOpenThemePanel: () => void;
}

export default React.createContext({} as IDrawerFormsContext);
